import { render } from "./CustomerModal.vue?vue&type=template&id=b646ed3e&scoped=true"
import script from "./CustomerModal.vue?vue&type=script&lang=js"
export * from "./CustomerModal.vue?vue&type=script&lang=js"

import "./CustomerModal.vue?vue&type=style&index=0&id=b646ed3e&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b646ed3e"]])

export default __exports__